export default "__VITE_ASSET__D9_I_axK__"